import type {
	CmsExternalServiceLink,
	CmsExternalServiceLinkParameter,
} from '@gov-nx/api';
import { hasProperties, isNumber, isString } from '@gov-nx/core/types';

export type FormMethod = 'get' | 'post';

export const getFormMethod = (
	linkParameters: CmsExternalServiceLinkParameter[]
): FormMethod =>
	linkParameters?.some((param) => param.method === 'POST') ? 'post' : 'get';

export const getFormAction = (link: CmsExternalServiceLink): URL['href'] => {
	// test urls
	// 'https://rzp.gov.cz/trvaly-odkaz/cs/epo-jrf'
	const url = new URL(link.link);
	link.linkParameters
		?.filter(hasProperties(['name', 'value']))
		.forEach((param) => {
			if (param.method === 'GET') {
				url.searchParams.append(param.name, param.value);
			}
		});
	return url.href;
};

export const isValidParameterInputKeyValue = (param: {
	name: string;
	value: string | number | undefined;
}): param is { name: string; value: string | number } =>
	isString(param.name) || isNumber(param.value);
